import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import userReducer from './users'

export type RootState = {
  user: ReturnType<typeof userReducer>
}

const createStore = (initialState?: Partial<RootState>) => {
  return configureStore({
    reducer: {
      user: userReducer,
    },
    middleware: [thunk],
    preloadedState: initialState,
  })
}

export default createStore
